import {createStore, StoreApi} from 'zustand/vanilla';
import {RunnerInterface} from '../models/runner';

interface SearchResultsState {
    runners: Array<RunnerInterface>;
    setRunners: (newRunners: Array<RunnerInterface>) => void;
}

export type SearchResultsStore = SearchResultsState & StoreApi<SearchResultsState>;

const store = createStore<SearchResultsState>((set) => ({
    runners: [],
    setRunners: (newRunners) => set((state) => ({
        ...state,
        runners: newRunners,
    })),
}));

export default (): SearchResultsStore => ({
    ...store.getState(),
    ...store,
});
